import { useCallback, useRef } from 'react';
import { isBrowser } from '../utils';
import { sendRouteCardViewEvent, sendRouteCardClickEvent } from '../utils/analytics';

// Fires route_card_view once per card (via IntersectionObserver) and route_card_click on click.
export default function useRouteCardTracking(name, position, href) {
  const viewed = useRef(false);
  const observer = useRef(null);

  const ref = useCallback(
    (node) => {
      if (observer.current) {
        observer.current.disconnect();
        observer.current = null;
      }

      if (!node || viewed.current || !isBrowser || typeof IntersectionObserver === 'undefined') {
        return;
      }

      observer.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !viewed.current) {
            viewed.current = true;
            sendRouteCardViewEvent(name, position);
            observer.current.disconnect();
          }
        },
        { threshold: 0.5 }
      );
      observer.current.observe(node);
    },
    [name, position]
  );

  const onClick = useCallback(
    (event) => {
      sendRouteCardClickEvent(event, href, name, position);
    },
    [href, name, position]
  );

  return { ref, onClick };
}
